var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCloneIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_197",
    "data-name": "Path 197",
    d: "M0,0H16V16H0Z",
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1308",
    "data-name": "Group 1308",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_196",
    "data-name": "Path 196",
    d: "M10.667,1H3.333A1.337,1.337,0,0,0,2,2.333V11a.667.667,0,0,0,1.333,0V3A.669.669,0,0,1,4,2.333h6.667a.667.667,0,1,0,0-1.333Zm2.667,2.667H6A1.337,1.337,0,0,0,4.667,5v9.333A1.337,1.337,0,0,0,6,15.667h7.333a1.337,1.337,0,0,0,1.333-1.333V5A1.337,1.337,0,0,0,13.333,3.667Zm-.667,10.667h-6A.669.669,0,0,1,6,13.667v-8A.669.669,0,0,1,6.667,5h6a.669.669,0,0,1,.667.667v8A.669.669,0,0,1,12.667,14.333Z",
    transform: "translate(-0.667 -0.333)",
    fill: "#473f44"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloneIcon);
export default __webpack_public_path__ + "static/media/cloneIcon.a059e214ce70e2dac01ceb0678eb1619.svg";
export { ForwardRef as ReactComponent };